import { AxiosError } from 'axios';

export interface ErrorHandlerOptions {
    defaultMessage?: string;
    showToast: (message: string) => void;
}

/**
 * Универсальная функция для обработки ошибок
 * @param error - Ошибка любого типа
 * @param options - Настройки обработчика ошибок
 */
export function handleError(error: unknown, options: ErrorHandlerOptions): void {
    const {
        defaultMessage = "Произошла неизвестная ошибка",
        showToast
    } = options;

    let errorMessage = defaultMessage;

    if (error instanceof AxiosError) {
        if (error.response?.data?.details) {
            return;
        }
        errorMessage = error.response?.data?.message || error.response?.data?.error || "Ошибка сети";
    } else if (error instanceof Error) {
        errorMessage = error.message;
    } else if (typeof error === 'string') {
        errorMessage = error;
    } else if (error && typeof error === 'object' && 'message' in error) {
        errorMessage = String((error as { message: unknown }).message);
    }

    showToast(errorMessage);
}